<div class="filters-container" [class.compact]="compact">
  <div class="filter-field filter-field-wide">
    @if (!compact) {
      <label>{{ 'Agent Basis' | translate }}</label>
    }
    <mat-form-field appearance="outline" class="filter-select">
      <mat-select
        [ngModel]="values.agentId"
        (ngModelChange)="onAgentChange($event)"
        [placeholder]="'Worst Band' | translate"
        >
        <mat-option [value]="null">{{ 'Worst Band' | translate }}</mat-option>
        @for (agent of availableAgents; track trackByIndex($index)) {
          <mat-option
            [value]="agent.id"
          >{{ agent.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="filter-field filter-field-wide">
    @if (!compact) {
      <label>{{ 'Survey Type' | translate }}</label>
    }
    <mat-form-field appearance="outline" class="filter-select">
      <mat-select
        multiple
        [ngModel]="values.surveyTypeIds"
        (ngModelChange)="onSurveyTypesChange($event)"
        [placeholder]="'All Survey Types' | translate"
        >
        <mat-option>
          <ngx-mat-select-search
            [ngModel]="surveyTypes.query"
            (ngModelChange)="surveyTypes.search($event)"
            [placeholderLabel]="'Search' | translate"
            [noEntriesFoundLabel]="'No options found' | translate">
            @if (values.surveyTypeIds.length) {
              <app-multi-select-clear (cleared)="onSurveyTypesChange([])"></app-multi-select-clear>
            }
          </ngx-mat-select-search>
        </mat-option>
        @for (type of surveyTypes.display; track type.id) {
          <mat-option [value]="type.id">{{ type.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="filter-field filter-field-wide">
    @if (!compact) {
      <label>{{ 'Date Range' | translate }}</label>
    }
    <mat-form-field appearance="outline" class="filter-select">
      <mat-select
        [value]="values.dateFilterType"
        (valueChange)="onDateFilterChange($event)"
        [placeholder]="'All Dates' | translate"
        >
        @for (opt of dateRangeOptionsWithRange; track trackByIndex($index)) {
          <mat-option
            [value]="opt.value"
          >{{ opt.value === DateFilterTypeEnum.Custom ? customDateLabel : opt.displayName }}</mat-option>
        }
      </mat-select>
      @if (values.dateFilterType === DateFilterTypeEnum.Custom) {
        <button
          matSuffix mat-icon-button
          type="button"
          (click)="$event.stopPropagation(); openCustomDateDialog(values.dateFilterType)"
          [attr.aria-label]="'Edit custom date range' | translate">
          <mat-icon>edit_calendar</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <ng-content select="[filterAppend]"></ng-content>
</div>
